
import React from 'react';
import { DropdownLabel, Image } from '../../../../ui-kit';











function MentionItem(
{
  mention: { name, imageUrl },
  searchValue,
  isFocused,
  ...parentProps
}) {
  const prefix =
  <Image
    height="20px"
    width="20px"
    imageUrl={imageUrl}
    placeholderText={name}
    placeholderTextSize={10}
    circular
    backgroundSize="cover" />;



  const data = {
    prefix,
    label: name
  };

  return (
    <div
      {...parentProps}
      className="mention-item"
      role="menuitem">

      <DropdownLabel data={data} />
    </div>);

}

export default MentionItem;